module.exports = __webpack_public_path__ + "/img/Crystal-HC49-VWrMHW.svg";